require(119);
module.exports = require(23).RegExp.escape;